import React from 'react';
import { View, StyleSheet, Pressable } from 'react-native';
import { Ionicons } from '@expo/vector-icons';
import { Text, Theme } from '../../../components/ui';

interface EmptyBookPlaceholderProps {
  onPress: () => void;
}

/**
 * Empty Book Placeholder Component
 * Visual placeholder for adding books to collection
 * Always displayed at the end of the user's reading list
 */
const EmptyBookPlaceholder: React.FC<EmptyBookPlaceholderProps> = ({
  onPress,
}) => {
  return (
    <Pressable
      style={styles.container}
      onPress={onPress}
      testID="empty-placeholder"
      accessible={true}
      accessibilityRole="button"
      accessibilityLabel="Add new book to your reading list"
      accessibilityHint="Double tap to browse books in the explore section"
    >
      <View style={styles.bookCover}>
        <Ionicons name="add" size={48} color={Theme.colors.primary} />
      </View>
      <Text style={styles.text} numberOfLines={2}>
        Add new book to your reading list
      </Text>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  container: {
    width: 120,
    marginRight: Theme.spacing.md,
    alignItems: 'center',
  },
  bookCover: {
    width: 120,
    height: 180,
    borderRadius: Theme.borderRadius.md,
    backgroundColor: Theme.colors.surface,
    borderWidth: 2,
    borderColor: Theme.colors.border,
    borderStyle: 'dashed',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: Theme.spacing.sm,
  },
  text: {
    fontSize: 12,
    fontFamily: Theme.typography.fontFamily.medium,
    color: Theme.colors.textSecondary,
    textAlign: 'center',
    lineHeight: 16,
  },
});

export default EmptyBookPlaceholder;
